<template>
    <div class="categories">
        <h2 v-if="showTitle">{{ translate('support.categoryTitle') }}</h2>
        <UIGridRow gutter="small">
            <UIGridCol v-for="category in mainCategories" :key="category.name" cols="6" md="4" class="mb-3">
                <nuxt-link
                    :to="
                        $locale.path({ name: 'support-category', params: { category: category.translations[0].slug } })
                    "
                    :class="{ active: category.id === currentCategoryId }"
                    :title="category.name"
                    class="category d-flex flex-column align-items-center py-4">
                    <UIIcon class="category-icon" :name="category.icon"></UIIcon>
                    <div class="title">{{ category.translations[0].translation.title }}</div>
                </nuxt-link>
            </UIGridCol>
        </UIGridRow>
    </div>
</template>

<script>
import { UIGridCol, UIGridRow, UIIcon } from '@dundle/ui/components';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    components: {
        UIGridCol,
        UIGridRow,
        UIIcon,
    },

    mixins: [TranslationMixin],

    props: {
        showTitle: Boolean,
        categories: Array,
        currentCategoryId: String,
    },

    data() {
        return {
            supportCategories: [
                { name: 'Voucher Issues', icon: 'barcode-alt' },
                { name: 'My Order', icon: 'shopping-cart' },
                { name: 'Payment Questions', icon: 'wallet' },
                { name: 'Refunds', icon: 'undo-alt' },
                { name: 'Online Security', icon: 'user-shield' },
                { name: 'Other Topics', icon: 'comment-dots' },
            ],
        };
    },

    computed: {
        mainCategories() {
            return this.categories.map(category => {
                const supportCategory = this.supportCategories.find(cat => cat.name === category.name);
                return {
                    ...category,
                    ...supportCategory,
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.category {
    border: 1px solid $color-grey-4;
    border-radius: $border-radius-default;
    // padding: 1.7rem 0;
    text-decoration: none;
    //
    height: 100%;

    &:hover {
        border-color: transparent;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
    }

    &.active {
        border-color: $color-primary;
        box-shadow: none;
        pointer-events: none;
        cursor: pointer;
        .category-icon,
        .title {
            color: $color-primary;
        }
    }

    .category-icon {
        color: $color-primary-dark;
        font-size: 1.3rem;
        margin-top: 0.3rem;
        margin-bottom: 0.75rem;

        @media screen and (min-width: 768px) {
            font-size: 2.4rem;
            margin-top: 1rem;
            margin-bottom: 1.4rem;
        }
    }

    .title {
        color: $color-primary-dark;
        font-weight: 700;
        font-size: 1rem;
        text-align: center;
        @media screen and (min-width: 768px) {
            font-size: 1.2rem;
        }
    }
}
</style>

<i18n src="@dundle/locale/data/support.json"></i18n>
